'use strict';
/* ─── State ──────────────────────────────────────────────────── */ const state = {
    mySex: null,
    myYear: null,
    myMonth: null,
    hisSex: null,
    hisYear: null,
    hisMonth: null,
    actType: null,
    act: null
};
/* ─── DOM references ─────────────────────────────────────────── */ const $ = (id)=>document.getElementById(id);
const els = {
    mySex: $('my_sex'),
    myYear: $('my_year'),
    myMonth: $('my_month'),
    hisSex: $('his_sex'),
    hisYear: $('his_year'),
    hisMonth: $('his_month'),
    actType: $('act_type'),
    act: $('act'),
    actAlt: $('act_alt'),
    actPanel: $('act-panel'),
    iwant: $('iwant'),
    hewants: $('hewants'),
    resultSection: $('result-section'),
    resultSummary: $('result-summary'),
    verdictCard: $('verdict-card')
};
/* ─── Helpers ────────────────────────────────────────────────── */ function isSet(v) {
    return v !== null && v !== undefined;
}
function markError(el, on) {
    if (on) {
        el.classList.add('is-error');
        el.setAttribute('aria-invalid', 'true');
    } else {
        el.classList.remove('is-error');
        el.removeAttribute('aria-invalid');
    }
    // Non-color error indicator (WCAG 1.4.1)
    const errorSpan = el.parentElement && el.parentElement.querySelector('.field-error');
    if (errorSpan) {
        if (on) {
            errorSpan.textContent = "Required \u2014 please select a value";
            errorSpan.classList.add('is-visible');
        } else {
            errorSpan.textContent = '';
            errorSpan.classList.remove('is-visible');
        }
    }
}
function addOpt(group, value, text) {
    const opt = document.createElement('option');
    opt.value = value;
    opt.textContent = text;
    group.appendChild(opt);
}
function resetResult() {
    els.resultSection.hidden = true;
    els.resultSummary.innerHTML = '';
    els.verdictCard.innerHTML = '';
    els.verdictCard.className = 'verdict-card';
}
/* ─── Populate acts ──────────────────────────────────────────── */ function showActs() {
    if (!isSet(state.actType) || !isSet(state.mySex) || !isSet(state.hisSex)) {
        els.actPanel.hidden = false;
        els.actAlt.hidden = false;
        els.act.hidden = true;
        return;
    }
    state.act = null;
    resetResult();
    // Clear optgroup contents — do NOT wipe the whole select (that orphans the optgroups)
    els.iwant.innerHTML = '';
    els.hewants.innerHTML = '';
    // Remove the standalone placeholder option if previously inserted
    if (els.act.firstElementChild && els.act.firstElementChild.tagName === 'OPTION') els.act.removeChild(els.act.firstElementChild);
    // Re-insert placeholder at the top
    const first = document.createElement('option');
    first.value = '';
    first.textContent = "Select an act\u2026";
    els.act.insertBefore(first, els.act.firstElementChild);
    els.act.hidden = false;
    els.actAlt.hidden = true;
    els.actPanel.hidden = false;
    markError(els.act, true);
    const my = state.mySex;
    const his = state.hisSex;
    const hisTxt = his === 0 ? 'male' : 'female';
    switch(state.actType){
        case '1':
            if (!my && his) {
                addOpt(els.iwant, '150', 'Insert my penis into my partner\'s vagina');
                addOpt(els.hewants, '150', 'Have my partner insert their penis into their vagina (me active)');
                addOpt(els.iwant, '150', 'Insert fingers into my partner\'s vagina');
                addOpt(els.hewants, '150', 'Have fingers inserted into my vagina');
                addOpt(els.iwant, '150', 'Insert an object into my partner\'s vagina');
                addOpt(els.hewants, '150', 'Have an object inserted into my vagina');
            }
            if (my && !his) {
                addOpt(els.iwant, '160', 'Have my partner insert their penis into my vagina');
                addOpt(els.hewants, '160', 'Insert my penis into my partner\'s vagina');
                addOpt(els.iwant, '160', 'Have fingers inserted into my vagina');
                addOpt(els.hewants, '160', 'Insert fingers into my partner\'s vagina');
            }
            if (!my && !his) {
                addOpt(els.iwant, '-1', 'Vaginal sex is not applicable between two males');
                addOpt(els.hewants, '-1', 'Vaginal sex is not applicable between two males');
            }
            if (my && his) {
                addOpt(els.iwant, '160', 'Have my partner insert fingers/object into my vagina');
                addOpt(els.hewants, '150', 'Insert fingers/object into my partner\'s vagina');
            }
            break;
        case '2':
            if (!my) {
                addOpt(els.iwant, '151', `Insert my penis into my ${hisTxt} partner's anus`);
                addOpt(els.iwant, '151', `Insert fingers into my ${hisTxt} partner's anus`);
                addOpt(els.iwant, '151', `Insert an object into my ${hisTxt} partner's anus`);
                if (!his) addOpt(els.hewants, '161', 'Have my partner insert their penis into my anus');
                addOpt(els.hewants, '161', 'Have fingers inserted into my anus');
                addOpt(els.hewants, '161', 'Have an object inserted into my anus');
            }
            if (my && !his) {
                addOpt(els.iwant, '161', 'Have my partner insert their penis into my anus');
                addOpt(els.hewants, '161', 'Insert my penis into my partner\'s anus');
                addOpt(els.iwant, '161', 'Have fingers/object inserted into my anus');
                addOpt(els.hewants, '161', 'Insert fingers/object into my partner\'s anus');
            }
            if (my && his) {
                addOpt(els.iwant, '161', 'Have my partner insert fingers/object into my anus');
                addOpt(els.hewants, '161', 'Insert fingers/object into my anus');
                addOpt(els.iwant, '151', 'Insert fingers/object into my partner\'s anus');
                addOpt(els.hewants, '151', 'Have fingers/object inserted into my anus (me active)');
            }
            break;
        case '3':
            if (!his) addOpt(els.iwant, '161', 'Perform oral sex on my male partner');
            else {
                addOpt(els.iwant, '119', 'Perform oral sex on my female partner (without tongue insertion)');
                addOpt(els.iwant, '150', 'Perform oral sex on my female partner (with tongue insertion)');
            }
            if (my) {
                addOpt(els.hewants, '119', 'Have my partner perform oral sex on me (without insertion)');
                addOpt(els.hewants, '150', 'Have my partner perform oral sex on me (with insertion)');
            } else addOpt(els.hewants, '151', 'Have my partner perform oral sex on me');
            addOpt(els.iwant, '119', `Lick my ${hisTxt} partner's anus (without insertion)`);
            addOpt(els.hewants, '119', 'Have my partner lick my anus (without insertion)');
            addOpt(els.iwant, '161', `Lick my ${hisTxt} partner's anus (with tongue insertion)`);
            addOpt(els.hewants, '161', 'Have my partner lick my anus (with tongue insertion)');
            break;
        case '4':
            addOpt(els.iwant, '102', 'Lie together with one of us clothed (dry humping)');
            addOpt(els.hewants, '102', 'Lie together with one of us clothed (dry humping)');
            addOpt(els.iwant, '103', 'Lie together naked without any penetration');
            addOpt(els.hewants, '103', 'Lie together naked without any penetration');
            if (!my) addOpt(els.iwant, '128', `Ejaculate on my ${hisTxt} partner (including genitals)`);
            if (!his) addOpt(els.hewants, '128', 'Have my partner ejaculate on me');
            break;
        case '5':
            if (!his) addOpt(els.iwant, '104', 'Manually stimulate my male partner (handjob)');
            else {
                addOpt(els.iwant, '105', 'Manually stimulate my female partner (without insertion)');
                addOpt(els.iwant, '150', 'Manually stimulate my female partner (with finger insertion)');
            }
            if (!my) addOpt(els.hewants, '104', 'Have my partner manually stimulate me (handjob)');
            else {
                addOpt(els.hewants, '105', 'Have my partner manually stimulate me (without insertion)');
                addOpt(els.hewants, '160', 'Have my partner manually stimulate me (with finger insertion)');
            }
            break;
        case '6':
            addOpt(els.iwant, '115', `French kiss my ${hisTxt} partner (with tongue)`);
            addOpt(els.hewants, '115', 'French kiss me (with tongue)');
            addOpt(els.iwant, '116', `Kiss my ${hisTxt} partner (without tongue)`);
            addOpt(els.hewants, '116', 'Kiss me (without tongue)');
            addOpt(els.iwant, '117', `Touch my ${hisTxt} partner's genitals (without insertion)`);
            addOpt(els.hewants, '117', 'Have my partner touch my genitals (without insertion)');
            addOpt(els.iwant, '150', `Touch my ${hisTxt} partner's genitals (with finger insertion)`);
            addOpt(els.hewants, '160', 'Have my partner touch my genitals (with finger insertion)');
            addOpt(els.iwant, '119', `Kiss/lick my ${hisTxt} partner's genitals (without insertion)`);
            addOpt(els.hewants, '119', 'Have my partner kiss/lick my genitals (without insertion)');
            addOpt(els.iwant, '150', `Kiss/lick my ${hisTxt} partner's genitals (with insertion)`);
            addOpt(els.hewants, '160', 'Have my partner kiss/lick my genitals (with insertion)');
            addOpt(els.iwant, '121', `Hug my ${hisTxt} partner while naked (sexual context)`);
            addOpt(els.hewants, '121', 'Have my partner hug me while naked (sexual context)');
            addOpt(els.iwant, '129', `Hug my ${hisTxt} partner while clothed (sexual context)`);
            addOpt(els.hewants, '129', 'Have my partner hug me while clothed (sexual context)');
            break;
    }
}
/* ─── Calculate ──────────────────────────────────────────────── */ function calculate() {
    const myMonthRequired = isSet(state.myYear) && state.myYear !== 19;
    const hisMonthRequired = isSet(state.hisYear) && state.hisYear !== 19;
    const ready = isSet(state.mySex) && isSet(state.myYear) && (!myMonthRequired || isSet(state.myMonth)) && isSet(state.hisSex) && isSet(state.hisYear) && (!hisMonthRequired || isSet(state.hisMonth)) && isSet(state.act) && state.act !== '' && state.act !== '-1';
    if (!ready) {
        resetResult();
        return;
    }
    const myAge = state.myYear + (myMonthRequired ? state.myMonth : 0) / 12;
    const hisAge = state.hisYear + (hisMonthRequired ? state.hisMonth : 0) / 12;
    const eitherUnder14 = myAge < 14 || hisAge < 14;
    const bothOver16 = myAge >= 16 && hisAge >= 16;
    const meOver16 = myAge >= 16;
    const partnerOver16 = hisAge >= 16;
    const over3Years = Math.abs(myAge - hisAge) >= 3;
    const bothOver18 = myAge >= 18 && hisAge >= 18;
    let specialWarning = false;
    if ((Math.floor(myAge) === 16 || Math.floor(myAge) === 17) && hisAge >= 18) specialWarning = true;
    if ((Math.floor(hisAge) === 16 || Math.floor(hisAge) === 17) && myAge >= 18) specialWarning = true;
    const mySexTxt = state.mySex === 0 ? 'Male' : 'Female';
    const hisSexTxt = state.hisSex === 0 ? 'Male' : 'Female';
    const myAgeTxt = state.myYear < 13 ? 'under 13 years old' : state.myYear > 18 ? 'over 19 years old' : `${state.myYear} years${state.myMonth === 0 ? '' : ` and ${state.myMonth} months`}`;
    const hisAgeTxt = state.hisYear < 13 ? 'under 13 years old' : state.hisYear > 18 ? 'over 19 years old' : `${state.hisYear} years${state.hisMonth === 0 ? '' : ` and ${state.hisMonth} months`}`;
    const actEl = els.act;
    const selOpt = actEl.options[actEl.selectedIndex];
    const actParent = selOpt ? selOpt.parentElement.getAttribute('label') : '';
    const actTxt = actParent === "I want to\u2026" ? `I want to: ${selOpt.textContent}` : `My partner wants to: ${selOpt.textContent}`;
    const action = state.act;
    let allowed = false;
    let explanation = '';
    const ALLOWED = 'Permitted with mutual consent';
    const NOT_ALLOWED = 'Not permitted';
    if (bothOver16) {
        allowed = true;
        explanation = ALLOWED;
    } else {
        const evalStandard = (forbiddenText)=>{
            if (eitherUnder14) {
                allowed = false;
                explanation = `${NOT_ALLOWED} ${forbiddenText}`;
            } else if (!meOver16 || !partnerOver16) {
                if (over3Years) {
                    allowed = false;
                    explanation = `${NOT_ALLOWED} (considered indecent act in public, Penal Code \xa7349(b))`;
                } else {
                    allowed = true;
                    explanation = ALLOWED;
                }
            } else {
                allowed = true;
                explanation = ALLOWED;
            }
        };
        switch(action){
            case '128':
            case '102':
            case '103':
            case '105':
            case '104':
            case '116':
            case '115':
            case '117':
            case '119':
            case '121':
            case '129':
                evalStandard("(considered an indecent act, Penal Code \xa7348(b))");
                break;
            case '160':
            case '150':
                if (eitherUnder14) {
                    allowed = false;
                    explanation = `${NOT_ALLOWED} (considered rape, Penal Code \xa7345(a)(3))`;
                } else if (!meOver16 || !partnerOver16) {
                    if (over3Years) {
                        allowed = false;
                        explanation = `${NOT_ALLOWED} (considered statutory rape with consent, Penal Code \xa7346(a)(1))`;
                    } else {
                        allowed = true;
                        explanation = ALLOWED;
                    }
                } else {
                    allowed = true;
                    explanation = ALLOWED;
                }
                break;
            case '161':
            case '151':
                if (eitherUnder14) {
                    allowed = false;
                    explanation = `${NOT_ALLOWED} (considered rape, Penal Code \xa7347(b))`;
                } else if (!meOver16 || !partnerOver16) {
                    if (over3Years) {
                        allowed = false;
                        explanation = `${NOT_ALLOWED} (considered sodomy offense, Penal Code \xa7347(a)(1))`;
                    } else {
                        allowed = true;
                        explanation = ALLOWED;
                    }
                } else {
                    allowed = true;
                    explanation = ALLOWED;
                }
                break;
            default:
                resetResult();
                return;
        }
    }
    let notice = '';
    if (specialWarning) notice = "Note: Special relationships (e.g., therapist-patient, teacher-student) may be prohibited even when the younger partner is 16\u201317 and the other is 18+.";
    else if (bothOver18) notice = 'Note: Certain professional relationships (e.g., therapist-patient, spiritual advisor) may be subject to additional restrictions even between adults.';
    els.resultSummary.innerHTML = `
    <p>I am ${mySexTxt}, ${myAgeTxt}.</p>
    <p>My partner is ${hisSexTxt}, ${hisAgeTxt}.</p>
    <p>${actTxt}.</p>`;
    const iconOk = `<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`;
    const iconNo = `<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
    els.verdictCard.className = `verdict-card ${allowed ? 'is-allowed' : 'is-denied'}`;
    els.verdictCard.innerHTML = `
    <div class="verdict-title">
      ${allowed ? iconOk : iconNo}
      <span>${allowed ? 'Permitted' : 'Not Permitted'}</span>
    </div>
    <p class="verdict-explanation">${explanation}.</p>
    ${notice ? `<p class="verdict-notice">${notice}</p>` : ''}`;
    els.resultSection.hidden = false;
    els.resultSection.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
    });
    try {
        if (typeof gtag !== 'undefined') gtag('event', allowed ? 'allowed' : 'not_allowed', {
            event_category: 'Calculator',
            event_label: `${mySexTxt}-${myAgeTxt}|${hisSexTxt}-${hisAgeTxt}|${actTxt}`
        });
    } catch (_) {}
}
/* ─── Event wiring ───────────────────────────────────────────── */ function onChange(el, stateKey, transform, after) {
    el.addEventListener('change', ()=>{
        if (el.value !== '') {
            markError(el, false);
            state[stateKey] = transform ? transform(el.value) : el.value;
            if (after) after();
        } else {
            markError(el, true);
            state[stateKey] = null;
        }
    });
}
onChange(els.mySex, 'mySex', (v)=>parseInt(v, 10), ()=>showActs());
onChange(els.hisSex, 'hisSex', (v)=>parseInt(v, 10), ()=>showActs());
onChange(els.myYear, 'myYear', (v)=>parseInt(v, 10), ()=>{
    if (state.myYear === 19) {
        els.myMonth.value = '0';
        els.myMonth.disabled = true;
        markError(els.myMonth, false);
        state.myMonth = 0;
    } else els.myMonth.disabled = false;
    calculate();
});
onChange(els.myMonth, 'myMonth', (v)=>parseInt(v, 10), ()=>calculate());
onChange(els.hisYear, 'hisYear', (v)=>parseInt(v, 10), ()=>{
    if (state.hisYear === 19) {
        els.hisMonth.value = '0';
        els.hisMonth.disabled = true;
        markError(els.hisMonth, false);
        state.hisMonth = 0;
    } else els.hisMonth.disabled = false;
    calculate();
});
onChange(els.hisMonth, 'hisMonth', (v)=>parseInt(v, 10), ()=>calculate());
onChange(els.actType, 'actType', null, ()=>showActs());
onChange(els.act, 'act', null, ()=>calculate());

//# sourceMappingURL=index-en.76521e40.js.map
